"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Button_component_exports = {};
__export(Button_component_exports, {
  Button: () => Button
});
module.exports = __toCommonJS(Button_component_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_react = __toESM(require("react"));
var import_button = require("@react-aria/button");
var import_link = require("@react-aria/link");
var import_utils = require("@react-aria/utils");
var import_clsx = __toESM(require("clsx"));
const Label = ({
  variant,
  children,
  className,
  usage,
  semanticLabel = "span"
}) => {
  const labelBaseClasses = `gmui-font-primary gmui-button-${variant}-label`;
  const labelAccordionClasses = usage == "accordion" || usage == "accordionWithCheckbox" ? `text-large themed-font-weight-body-medium gmui-button-accordion-label` : `text-medium`;
  const CustomSemanticTag = semanticLabel;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    CustomSemanticTag,
    {
      className: (0, import_clsx.default)(labelBaseClasses, className, labelAccordionClasses, ["m-0"]),
      children
    }
  );
};
const Icon = ({ variant, className, children, usage }) => {
  const buttonIconBaseClass = `gmui-button-${variant}-icon`;
  let buttonIconAccordionClass = "flex";
  if (usage == "accordion") {
    buttonIconAccordionClass = "gmui-button-accordion-icon";
  } else if (usage == "accordionWithCheckbox") {
    buttonIconAccordionClass = "gmui-button-accordion-with-checkbox-icon";
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", { className: (0, import_clsx.default)(buttonIconBaseClass, buttonIconAccordionClass, className), children });
};
const Button = import_react.default.forwardRef(
  (_a, ref) => {
    var _b = _a, {
      variant = "primary",
      size = "medium",
      className,
      children,
      id,
      usage,
      as = "button",
      testId
    } = _b, props = __objRest(_b, [
      "variant",
      "size",
      "className",
      "children",
      "id",
      "usage",
      "as",
      "testId"
    ]);
    let objRef = (0, import_utils.useObjectRef)(ref);
    let elementProps = {};
    if (as === "button") {
      elementProps = (0, import_button.useButton)(props, objRef);
    } else {
      elementProps = (0, import_link.useLink)(props, objRef);
    }
    const buttonBaseClass = "items-center justify-center self-center gmui-button";
    const buttonBaseDisplayClass = usage == "accordion" || usage == "accordionWithCheckbox" ? "grid" : "flex";
    const anchorBaseClass = "w-fit";
    const verticalPadding = usage == "accordionWithCheckbox" ? `var(--button-padding-large-vertical)` : `var(--button-padding-${size}-vertical)`;
    const horizontalPadding = usage == "accordion" || usage == "accordionWithCheckbox" ? `var(--button-padding-large-horizontal)` : `var(--button-padding-${size}-horizontal)`;
    let labelInterceptor = null;
    let leftIconInterceptor = null;
    let rightIconInterceptor = null;
    let withLabelClass = "";
    const childrenInterceptor = import_react.Children.map(children, (child) => {
      if (!(0, import_react.isValidElement)(child)) return child;
      if (child.type === Label) {
        labelInterceptor = (0, import_react.cloneElement)(child, {
          variant,
          id,
          semanticLabel: child.props.semanticLabel,
          usage
        });
        withLabelClass = usage == "accordion" || usage == "accordionWithCheckbox" ? (0, import_clsx.default)(
          "text-left",
          "justify-left",
          `${usage == "accordionWithCheckbox" ? "pl-[2.625rem] pr-4 gmui-button-accordion-with-checkbox-label" : "pl-m"}`
        ) : (0, import_clsx.default)("text-center", "flex", "items-center", "justify-center");
        return null;
      }
      if (child.type === Icon) {
        const iconProps = child.props;
        if (iconProps.position === "right") {
          rightIconInterceptor = (0, import_react.cloneElement)(child, {
            variant
          });
        } else {
          leftIconInterceptor = (0, import_react.cloneElement)(child, {
            variant,
            usage
          });
        }
        return null;
      }
      return child;
    });
    const handleKeyInteraction = (0, import_react.useCallback)(
      (e, action) => {
        if (e.key === " " || e.key === "Enter") {
          e.currentTarget.classList[action]("active");
        }
      },
      []
    );
    const handleBlur = (0, import_react.useCallback)((e) => {
      e.currentTarget.classList.remove("active");
    }, []);
    const Element = as;
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
      Element,
      __spreadProps(__spreadValues({}, as === "button" ? elementProps.buttonProps : elementProps.linkProps), {
        ref: objRef,
        className: (0, import_clsx.default)([
          buttonBaseClass,
          buttonBaseDisplayClass,
          `gmui-button-${variant}`,
          as === "a" ? anchorBaseClass : "",
          usage == "accordion" ? "gmui-button-accordion-grid" : usage == "accordionWithCheckbox" ? "gmui-button-accordion-with-checkbox-grid" : "gap-s",
          className
        ]),
        style: {
          // Add padding all around if there's only an icon
          padding: labelInterceptor ? `${verticalPadding} ${horizontalPadding}` : `${verticalPadding}`,
          height: usage == "accordion" || usage == "accordionWithCheckbox" ? `100%` : `var(--button-height-${size})`,
          // For buttons that only contains an icon,
          // we set the width as the height to make it perfectly circular/square
          width: labelInterceptor == null && `var(--button-height-${size})`
        },
        onKeyDown: (e) => handleKeyInteraction(e, "add"),
        onKeyUp: (e) => handleKeyInteraction(e, "remove"),
        onTouchStart: as === "button" && elementProps.buttonProps.onClick,
        "data-testid": `gmui-button${testId ? `-${testId}` : ""}`,
        id,
        onBlur: handleBlur,
        children: [
          leftIconInterceptor,
          labelInterceptor && /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { className: (0, import_clsx.default)(withLabelClass), children: labelInterceptor }),
          childrenInterceptor,
          rightIconInterceptor
        ]
      })
    );
  }
);
Button.Label = Label;
Button.Icon = Icon;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Button
});
//# sourceMappingURL=Button.component.js.map